import { render, staticRenderFns } from "./ManufacturingView.vue?vue&type=template&id=30983a8c&scoped=true&"
import script from "./ManufacturingView.vue?vue&type=script&lang=js&"
export * from "./ManufacturingView.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingView.vue?vue&type=style&index=0&id=30983a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30983a8c",
  null
  
)

export default component.exports